import React, {useCallback, useEffect, useRef, useState} from 'react';
import { useParams, useHistory } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import Breadcrumbs from "@base/Breadcrumbs";
import Toast from '@base/Toast'
import Loading from '@base/Loading';
import Title from '@base/Title';
import { ButtonSecondary, ButtonDefault } from '@base/Button/Button';

import EscolaService from "@services/EscolaService";

import PaperCartaoDuplicado from "./PaperCartaoDuplicado";

import useStatusCartao from '@hooks/enums/useStatusCartao';

export const TratamentoCartoesDuplicados = () => {
  const params = useParams();
  const history = useHistory();
  const toastRef = useRef(null);

  const breadcrumbs = [{
    path: "/" + params.processo + "/cartoes/duplicados",
    name: 'Tratamento de cartões Duplicados'
  }];

  const pageName = `${params.codigo}`;

  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();
  const [cartoes, setCartoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [blob, setBlob] = useState({});

  const [ proximoCartao, setProximoCartao ] = useState("");

  const listagemStatus = useStatusCartao();

  function convertStringToDate(dateString) {
    const parts = dateString.split('/');
    return new Date(parts[2], parts[1] - 1, parts[0]); // Mês é indexado em 0, subtrai 1
  }

  const visualizarArquivo = useCallback((cartao) => {    
    if (cartao.nomeArquivo !== null) {
      EscolaService.downloadArquivoCartaoSegmentado(params.processo, undefined, cartao.id)
        .then(resultado => {
          setBlob(prevBlob => ({
            ...prevBlob,
            [cartao.id]: resultado.data
          }));
        })
        .catch(erro => {
          toastRef.current.show("error", "Não foi possível fazer download do arquivo.");
        });
    }
  },[params.processo]);

  const carregaInformacoesDoCartaoClonado = useCallback(() => {    
    if (params.processo) {
      EscolaService.buscarCartoesPorCodigoOriginal(params.processo, params.codigo)
        .then((resultado) => {
          setCartoes(resultado.data);
          setLoading(false);

          resultado.data.forEach(cartao => visualizarArquivo(cartao));
        })
        .catch(erro => erro);
    }
  }, [params.processo, params.codigo, visualizarArquivo]);

  const carregaProximoCartaoClonado = useCallback(() => {
    EscolaService.buscarCartoes(params.processo, [{ field: 'comDuplicidade', value: "DUPLICIDADE_NAO_TRATADA" }])
      .then(resultado => {
        const { content } = resultado.data;
        const proximoCartao = content.find(c => c.codigo !== params.codigo);
        setProximoCartao(proximoCartao.codigo);
      });
  }, [params.codigo, params.processo]);

  useEffect(() => {
    setLoading(true);    
    carregaInformacoesDoCartaoClonado();
    carregaProximoCartaoClonado();
  }, [params.codigo, carregaInformacoesDoCartaoClonado, carregaProximoCartaoClonado, horaUltimoRefresh]);

  const cartoesOrdenados = cartoes.reduce((acc, cartao) => {

    if (cartao.status === 'DESCARTADO') {
      acc.descartados.push(cartao);
    } else {
      acc.naoDescartados.push(cartao);
    }
    return acc;
  }, {naoDescartados: [], descartados: []});

  cartoesOrdenados.naoDescartados.sort((a, b) => {
    const dateA = convertStringToDate(a.dataRecebimento);
    const dateB = convertStringToDate(b.dataRecebimento);
    return dateA - dateB;
  });

  const todosOsCartoes = [...cartoesOrdenados.naoDescartados, ...cartoesOrdenados.descartados];

  return (
    <>
      <Toast ref={toastRef}/>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Breadcrumbs links={breadcrumbs} active={pageName}/>
        </Grid>
      </Grid>

      <Title>Tratamento de Cartões Duplicados</Title>
      <br />

      {loading ?
        <Loading/>
      :
        <>
          <Grid container spacing={2} >
            <Grid item xs={6} >
              { todosOsCartoes.length === 1 ?
                <Alert severity="warning">Não Foram Encontrados Registros para Exibição</Alert>
              :
                <>
                  { todosOsCartoes.slice(1).map((cartao) => (
                    <PaperCartaoDuplicado
                      listagemStatus={listagemStatus.data}
                      cartao={cartao}
                      blob={blob[cartao.id]}
                      cartoes={cartoes}
                      processo={params.processo}
                      onCartoesUpdate={() => setHoraUltimoRefresh(new Date())}
                    />
                  ))}
                </>
              }
            </Grid>

            <Grid item xs={6}>
              <PaperCartaoDuplicado
                listagemStatus={listagemStatus.data}
                cartao={todosOsCartoes[0]}
                blob={blob[todosOsCartoes[0].id]}
                cartoes={cartoes}
                processo={params.processo}
                onCartoesUpdate={() => setHoraUltimoRefresh(new Date())}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems='flex-end' style={{ marginTop: 16 }}>
            { proximoCartao &&
              <Grid item sm={12} lg={4}>
                <ButtonDefault
                  startIcon={<ArrowForwardIcon />}
                  style={{ margin: 4 }}
                  onClick={() => history.push(`/${params.processo}/tratamentoCartoesDuplicados/${proximoCartao}`)}
                  name={`Ir Para o Próximo Tratamento`}
                />
              </Grid>
            }

            <Grid item sm={12} lg={12}>
              <ButtonSecondary
                startIcon={<ArrowBackIcon />}
                style={{ margin: 4 }}
                onClick={history.goBack}
                name={"Voltar"}
              />
            </Grid>
          </Grid>
        </>
      }
    </>
  );
}

export default TratamentoCartoesDuplicados;
